// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolTipButton {
  border: none;
  background: transparent;
}
.toolTipButton:hover {
  cursor: pointer;
}
.customScroll::-webkit-scrollbar-track {
  background-color: red !important;
}

/* Heartbeat loader: pulsing logo with expanding ping rings behind it */
.icon-loader-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.gy-heartbeat-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: gy-heartbeat-ping 1.6s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.gy-heartbeat-ring--accent {
  background-color: rgba(230, 97, 106, 0.3);
}

.gy-heartbeat-ring--accentLight {
  background-color: rgba(230, 116, 97, 0.2);
  animation-delay: 0.5s;
}

.gy-heartbeat-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -o-object-fit: contain;
     object-fit: contain;
  animation: gy-heartbeat-pulse 1.6s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes gy-heartbeat-ping {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes gy-heartbeat-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../libs/html/components/build/assets/components.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qEAAqE;AACvE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAmB;KAAnB,mBAAmB;EACnB,wEAAwE;AAC1E;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;;IAEE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".toolTipButton {\n  border: none;\n  background: transparent;\n}\n.toolTipButton:hover {\n  cursor: pointer;\n}\n.customScroll::-webkit-scrollbar-track {\n  background-color: red !important;\n}\n\n/* Heartbeat loader: pulsing logo with expanding ping rings behind it */\n.icon-loader-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.gy-heartbeat-ring {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  animation: gy-heartbeat-ping 1.6s cubic-bezier(0, 0, 0.2, 1) infinite;\n}\n\n.gy-heartbeat-ring--accent {\n  background-color: rgba(230, 97, 106, 0.3);\n}\n\n.gy-heartbeat-ring--accentLight {\n  background-color: rgba(230, 116, 97, 0.2);\n  animation-delay: 0.5s;\n}\n\n.gy-heartbeat-logo {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  object-fit: contain;\n  animation: gy-heartbeat-pulse 1.6s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes gy-heartbeat-ping {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  75%,\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n@keyframes gy-heartbeat-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
